import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  headers: HttpHeaders = new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' });
  
  constructor(private http: HttpClient) {}

  /**
   * submits client payment details to order
   * @param paymentDetails
   */
  submitPayment(paymentDetails: any) {
    return this.http.post(
      'order-payment', paymentDetails)
      .pipe(map(response => response));
  }

}
